import { render, staticRenderFns } from "./InfoCuponAmigoConsumido.vue?vue&type=template&id=86954278&"
import script from "./InfoCuponAmigoConsumido.vue?vue&type=script&lang=js&"
export * from "./InfoCuponAmigoConsumido.vue?vue&type=script&lang=js&"
import style0 from "./InfoCuponAmigoConsumido.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports